import { z } from 'zod';

// zod probes `new Function` to precompile validators; under our CSP (no 'unsafe-eval') that probe is
// blocked and reported as a violation. Skip it: validators then simply run interpreted.
z.config({ jitless: true });
